/**
 * Function to show/hide the back-to-top button
 */
(function ($) {
	// Run when DOM is ready
	$(function () {
		const topButton = document.getElementById('back-to-top');
		const breakpointHeight = 160; // Size to scroll to show a button (in pixels)
		const minDesktopWidth = 783; // Screens > 782px

		if (!topButton) {
			// Nothing to do if the button is not present on the page
			return;
		}

		function backToTop() {
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE & Opera
		}

		function updateBackToTopVisibility() {
			const isDesktop = window.innerWidth >= minDesktopWidth;
			const hasScrolled = document.body.scrollTop > breakpointHeight || document.documentElement.scrollTop > breakpointHeight;
			const shouldShow = isDesktop && hasScrolled;

			topButton.style.opacity = shouldShow ? '1' : '0';
			topButton.style.pointerEvents = shouldShow ? 'auto' : 'none';
		}

		// Expose globally in case themes/templates call backToTop() inline
		window.backToTop = backToTop;

		// Show/hide the button on the scroll
		$(window).on('scroll resize', updateBackToTopVisibility);
		updateBackToTopVisibility();

		// Attach click handler
		topButton.addEventListener('click', backToTop, { passive: true });
	});
})(jQuery);
